export class NotificationsConfiguration {
  rootElementId?: string;
  listSize?: number = 10;
  ariaOwns?: string = "menu-appbar";
}

export class HandoversConfiguration {
  handoversHandling?: boolean = true;
}

export class WsConfiguration {
  userManagementUrl: string;
  applicationName: string;

  shouldRefreshOnReconnect?: boolean = false;
  pingInterval?: number = 30000;
  reconnectionInterval?: number = 2000;

  notifications?: NotificationsConfiguration = new NotificationsConfiguration();
  handovers?: HandoversConfiguration = new HandoversConfiguration();
  
  _url: string;
  url = (): string => {
    if (this._url) return this._url;
    let scheme = this.userManagementUrl.toLowerCase().startsWith("https:") ? "wss" : "ws";
    let host = this.userManagementUrl
      .replace(/^http(s?)/i, scheme)
      .replace(/\/+$/, "");
    this._url = `${host}/ws?ApplicationName=${this.applicationName}`;
    return this._url;
  };

  validateConfiguration(): boolean {
    return this.applicationName !== "" &&
      this.url() !== "" &&
      this.pingInterval > 5000;
  }
}
